module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-2021-1.37b053d5.jpg";